<!-- <p *ngIf="isUserInactive && isPre2020">
    Your status is not active. Credentialed practitioners with active status receive discounts on credential verification letters, wallet cards and other products. 
    Renew your status now to receive reduced fees.
</p> -->
<p>Your transaction is not complete until you checkout.
</p>

<h1 class="page-title">Product/Annual Fee Purchase</h1>
<app-product-list [showRemove]="true"></app-product-list>
<div *ngIf="products.length > 0" class="form-actions">
<button class="button button--secondary form-actions__item" type="button" (click)="onCancel()">Cancel</button>
<button class="button button--secondary form-actions__item" type="button" (click)="onContinue()">Continue Shopping</button>
<button class="button form-actions__item" type="button" (click)="onCheckout()">Checkout</button>
</div>